<template>
  <div
    ref="scroller"
    class="gw_table_head"
  >
    <slot name="before"></slot>
    <div class="gw_table_head_row">
      <slot name="th_before"></slot>
      <slot
        v-for="(item, key, index) in thead"
        :name="`th_${key}`"
        :item="item"
        :index="index"
        :sortConf="sortConf"
      >
        <TableHeadCell
          :sortConf="sortConf"
          :item="item"
          :tstPrefix="key"
          @click="$emit('click:th', item)"
        >
        </TableHeadCell>
      </slot>

      <TableHeadCell
        v-if="hasSpacer"
        class="role_spacer"
        style="order: 99"
      >
      </TableHeadCell>
    </div>
    <slot name="after"></slot>
  </div>
</template>

<script>
import TableHeadCell from '@/components/DataTables/v2/TableHeadCell'

export default {
  name: 'TableHead',
  components: {
    TableHeadCell,
  },
  props: {
    hasSpacer: { type: Boolean, default: true },
    thead: Object,
    sortConf: {
      default: () => ({
        sortOrder: 'desc',
        sortKey: 'name',
      }),
    },
  },
  emits: ['click:th', 'update:scroll'],
}
</script>
